const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'variant',
});

/**
 * Sorts strings alphabetically, but also takes into account numbers in the strings.
 *
 * @remarks
 * This function is useful for sorting strings that contain numbers, e.g. "Item 1", "Item 2", "Item 10".
 *
 * @param a - First string to compare
 * @param b - Second string to compare
 * @returns A negative number if a comes before b, a positive number if a comes after b, or 0 if they are equivalent
 */
export function sortAlphanumeric(a: string, b: string): number {
    return collator.compare(a, b);
}

/**
 * Sorts an array of objects by their sequence property in ascending order.
 *
 * @remarks
 * This function is useful for sorting arrays of objects that have a sequence property,
 * e.g. attributes, items, etc.
 *
 * @param array - Array of objects with a sequence property
 * @param descending - If true, sorts in descending order (default: false)
 * @returns A new sorted array
 */
export function sortBySequence<T extends { sequence: number }>(
    array: T[],
    descending = false,
): T[] {
    return array.slice().sort((a, b) => {
        return descending ? b.sequence - a.sequence : a.sequence - b.sequence;
    });
}
